// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import AudioVisual from 'vue-audio-visual';
import Vuetify from 'vuetify';
import VueAuth from '@websanova/vue-auth';
import AuthBearer from '@websanova/vue-auth/drivers/auth/bearer';
import AuthHttp from '@websanova/vue-auth/drivers/http/axios.1.x';
import AuthRouter from '@websanova/vue-auth/drivers/router/vue-router.2.x';
import VueOffline from 'vue-offline';
import jwt, { decode } from 'jsonwebtoken';
import NProgress from 'nprogress';
import VueRouter from 'vue-router';
import Echo from 'laravel-echo';
import LogRocket from 'logrocket';
import App from './App';
import store from './store';
import routes from './routes';
import EventBus from './event-bus';
import DetectDevice from './services/detectDevice';
import VeeValidate from './services/veeValidator';

import('vuetify/dist/vuetify.min.css');
import('../src/assets/css/style.css');
import('chartist/dist/chartist.min.css');
import('chartist-plugin-tooltips/dist/chartist-plugin-tooltip.css');

/*
import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'
import awsconfig from './aws-exports'
Amplify.configure(awsconfig)
Vue.use(AmplifyPlugin, AmplifyModules)
*/

window.Pusher = require('pusher-js');

/** Diagnóstico de conexión Pusher/Echo (consola). Fuera de prod o con VUE_APP_DEBUG_PUSHER=true */
const debugPusher =
  process.env.NODE_ENV !== 'production' ||
  process.env.VUE_APP_DEBUG_PUSHER === 'true';

if (debugPusher) {
  window.Pusher.logToConsole = true;
}

Vue.use(VueRouter);
Vue.use(VueOffline);

const router = new VueRouter({
  mode: 'history',
  routes,
});

router.afterEach((to) => {
  if (to.path !== '/loading-error' && Vue.auth.check()) {
    localStorage.setItem('lastUserPath', to.path);
  }
});

router.beforeEach((to, from, next) => {
  if (to.name !== 'FirstLogin' && to.name !== 'Login' && to.name !== 'NexusEmail' && to.name !== 'verificationCode' && to.name !== 'changePassword' && to.name !== 'duePassword') {
    const token = localStorage.getItem('default_auth_token');
    if (token) {
      const decoded = jwt.decode(token);
      if (decoded.user.status === 'pendiente') {
        next('first_login');
      } else if (!decoded.user.nexus_email && (parseInt(decoded.user.company_id, 10) !== 8230622 && parseInt(decoded.user.company_id, 10) !== 17322821519)) {
        next('nexus_email');
      } else if (!decoded.user.last_password && !sessionStorage.getItem('password')) {
        next({
          name: 'changePassword',
        });
      } else {
        const moment = require('moment');
        const current = moment().utc().subtract(1, 'month');
        const last = !decoded.user.last_password ? current : moment(decoded.user.last_password.created_at, 'YYYY-MM-DD HH:mm:ss');
        const diff = last.diff(current, 'days')
        if (!localStorage.getItem('changePassword')) {
          if (diff <= 0) {
            next({
              name: 'changePassword',
            });
          } else if (diff >=1  && diff <= 7) {
            if (!localStorage.getItem('duepass')) {
              next({
                name: 'duePassword',
              });
            } else {
              next();
            }
          } else {
            next();
          }
        } else {
          next();
        }
      }
    } else {
      next();
    }
  } else {
    next();
  }
});

Vue.router = router;


Vue.use(Vuetify);
Vue.use(AudioVisual);
Vue.use(VueAxios, axios);
Vue.use(DetectDevice);
Vue.use(VeeValidate, {
  inject: false,
  errorBagName: 'errors',
  fieldsBagName: 'fieldsBag',
  events: 'input|blur',
});
Vue.use(VueAuth, {
  auth: AuthBearer,
  http: AuthHttp,
  router: AuthRouter,
  rememberMe: true,
  parseUserData: data => data,
});
if (process.env.NODE_ENV === 'production') {
  LogRocket.init('4xaflm/colektia');
}

Vue.axios.defaults.baseURL = process.env.API_URL || 'http://localhost/api';
let pendingAxiosCalls = 0;

Vue.axios.interceptors.request.use((config) => {
  pendingAxiosCalls += 1;
  if (!NProgress.status) {
    NProgress.start();
  }
  const method = config.method.toUpperCase();
  if (method === 'PUT' || method === 'PATCH' || method === 'DELETE') {
    // eslint-disable-next-line
    config.headers.common['X-HTTP-Method-Override'] = method;
    // eslint-disable-next-line
    config.method = 'POST';
  }
  return config;
}, error => Promise.reject(error));

Vue.axios.interceptors.response.use((response) => {
  pendingAxiosCalls -= 1;
  store.commit('user/SET_USER_VPN_CONNECTION_STATUS', true);
  if (!pendingAxiosCalls) {
    NProgress.done();
  }
  return response;
}, async (error) => {
  const { response = {} } = error;
  pendingAxiosCalls -= 1;

  if (!pendingAxiosCalls) {
    NProgress.done();
  }

  if (response.status === 401 && window.location.href !== '/login' && window.location.href !== '/register') {
    window.location.href = '/login';
  } else if (response.status === 403) {
    EventBus.$emit('modal', 'No tiene permisos para realizar esta acción');
  } else if (response.status === 422) {
    EventBus.$emit('error', response.data.errors);
  } else if (response.status === 405) {
    EventBus.$emit('modal', response.data);
  } else if (response.status === 429) {
    EventBus.$emit('error', 'Muchas peticiones realizadas, espere un momento');
  } else if (response.status === 423) {
    EventBus.$emit('error', response.data.errors ? response.data.errors : 'Limite de la peticion superada');
  }

  if (
    store.getters['user/vpnConnected']
    && router.currentRoute.name !== 'VpnDisconnected'
    && !response.status
  ) {
    try {
      const axiosInstance = axios.create();
      await axiosInstance.get('httpstatus');
    } catch (e) {
      store.commit('user/SET_USER_VPN_CONNECTION_STATUS', false);
      if (router.currentRoute.path === '/login' || router.currentRoute.path === '/') {
        localStorage.clear();
      }
      await router.push('/loading-error');
    }
  }

  return Promise.reject(error);
});

window.Echo = new Echo({
  broadcaster: 'pusher',
  authEndpoint: `${(process.env.API_URL || 'http://local.business.colektia.com/').replace('.com/api/', '.com/')}broadcasting/auth`,
  auth: {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('default_auth_token')}`,
    },
  },
  key: process.env.PUSHER_KEY || '4c77bedda33dbece77e0',
  cluster: 'us2',
  encrypted: true,
});

if (debugPusher && window.Echo.connector && window.Echo.connector.pusher) {
  const { connection } = window.Echo.connector.pusher;
  connection.bind('state_change', (states) => {
    const prev = states && states.previous;
    const curr = states && states.current;
    console.info('[Pusher]', 'state_change', `${prev} → ${curr}`);
  });
  connection.bind('connected', () => {
    console.info('[Pusher]', 'connected', 'socket_id=', connection.socket_id);
  });
  connection.bind('error', (payload) => {
    console.error('[Pusher]', 'connection error', payload);
  });
  connection.bind('failed', () => {
    console.error(
      '[Pusher]',
      'failed — no se pudo mantener WebSocket (revisa red, firewall/VPN, cluster, PUSHER_KEY, bloqueadores, certificado TLS)',
    );
  });
  connection.bind('unavailable', () => {
    console.warn('[Pusher]', 'unavailable — sin transporte disponible o modo offline');
  });
  connection.bind('disconnected', () => {
    console.warn('[Pusher]', 'disconnected');
  });
}

/**
 * Resolves when Pusher has a socket id. Echo.socketId() is undefined until the WebSocket connects.
 */
window.waitForEchoSocketId = function waitForEchoSocketId(timeoutMs = 15000) {
  const echo = window.Echo;
  if (!echo || !echo.connector || !echo.connector.pusher) {
    return Promise.resolve(null);
  }
  const direct = echo.socketId();
  if (direct) {
    return Promise.resolve(direct);
  }
  const { connection } = echo.connector.pusher;
  return new Promise((resolve) => {
    let settled = false;
    const finish = () => {
      if (settled) return;
      settled = true;
      connection.unbind('connected', onConnected);
      clearTimeout(timer);
      resolve(echo.socketId() || connection.socket_id || null);
    };
    const onConnected = () => finish();
    if (connection.state === 'connected') {
      finish();
      return;
    }
    connection.bind('connected', onConnected);
    const timer = setTimeout(finish, timeoutMs);
  });
};
/*
//  Interceptors
function sendAmplify(data) {
  //
}

axios.interceptors.request.use((request) => {
  sendAmplify(request);
  return request;
});
*/
if (process.env.REAL_NODE_ENV === 'prod' || process.env.REAL_NODE_ENV === 'dev') {
  Vue.config.productionTip = false;
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  store,
  data() {
    return {
      detectDevice: DetectDevice,
    };
  },
});



// WEBPACK FOOTER //
// ./src/main.js